import { render, staticRenderFns } from "./ShareView.vue?vue&type=template&id=1907f616&scoped=true"
import script from "./ShareView.vue?vue&type=script&lang=js"
export * from "./ShareView.vue?vue&type=script&lang=js"
import style0 from "./ShareView.vue?vue&type=style&index=0&id=1907f616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907f616",
  null
  
)

export default component.exports